import React from 'react';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Spinner,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
    Label,
    FormGroup
} from "reactstrap";

export const CardRegister = ({ errorMessage, onChange, email, doRegister, onTermsOfUse, acceptedTerms }) => (
    <Card className="card-signup text-center">
        <CardHeader>
            <CardHeader className="card-login-header">
                <img src={require("assets/img/logo-promos.png")}></img>
                <h3 className="header text-center">{I18n[keyEnum.doRegister]}</h3>
            </CardHeader>
        </CardHeader>
        <CardBody>
            <Form action="" className="form" method="">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="nc-icon nc-single-02" />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Nome" type="text" onChange={(e) => onChange("name", e.target.value)} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="nc-icon nc-email-85" />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Email" type="email" defaultValue={email} onChange={(e) => onChange("email", e.target.value)} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="nc-icon nc-key-25" />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input
                        placeholder="Senha"
                        type="password"
                        autoComplete="off"
                        onChange={(e) => onChange("password", e.target.value)}
                    />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="nc-icon nc-key-25" />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input
                        placeholder="Confirmar Senha"
                        type="password"
                        autoComplete="off"
                        onChange={(e) => onChange("confirm_password", e.target.value)}
                    />
                </InputGroup>
                <FormGroup check className="mt-3">
                    <FormGroup check>
                    <Label check>
                        <Input defaultValue="" type="checkbox" onClick={(e) => onTermsOfUse(e.target.checked)}/>
                        Li e aceito os termos de uso{" "}
                        <span className="form-check-sign" />{" "}
                        <a href="https://www.aqto.com.br/termos" target="_blank">Ver Termos</a>
                    </Label>
                    </FormGroup>
                </FormGroup>
            </Form>
            {errorMessage && <span className="text-error text-center">{errorMessage}</span>}
        </CardBody>
        <CardFooter>
            <Button
                className="btn-round"
                color="warning"
                onClick={doRegister}
            >
                Registrar
                  </Button>
        </CardFooter>
    </Card>
)

export const RegisterInfo = ({ icon, title, description }) => (
    <div className="info-area info-horizontal">
        <div className="icon icon-primary">
            <i className={icon} />
        </div>
        <div className="description">
            <h5 className="info-title">{title}</h5>
            <p className="description">
                {description}
            </p>
        </div>
    </div>
)